import { RpgClientObject } from "./Object";

export class RpgClientPlayer extends RpgClientObject {
    _type = 'player'
}   